<template>
  <b-container>
    <div class="container-app">
      <b-card class="card-header">
        <b-row>
          <b-col md="2" class="pdv-quantidade">
            <slot name="quantidade"></slot>
          </b-col>
          <b-col md="6" class="pdv-pesquisa" @click="onSearchClick">
            <slot name="formulario"></slot>
          </b-col>
          <b-col md="4" class="pdv-valor">
            <slot name="valor"></slot>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </b-container>
</template>

<script>
export default {
  name: 'pdv-busca',
  props: {
    onSearchClick: {
      type: Function,
      required: false,
    },
  },
};
</script>

<style>
.card-header {
  border-bottom-right-radius: 20px !important;
  border-bottom-left-radius: 20px !important;
  margin-top: 5px;
  border: 0px;
  padding: 0 1rem;
}

.card-header .card-title {
  text-align: center;
  color: #fff;
}

.card-header .card-body {
  padding: 0px;
  color: #fff;
}

.pdv-pesquisa {
  background-color: var(--color-secondary);
}

.pdv-quantidade {
  background-color: var(--color-primary);
  border-bottom-left-radius: 20px !important;
  padding: 10px 10px 10px 15px;
}

.pdv-valor {
  background-color: var(--color-primary);
  border-bottom-right-radius: 20px !important;
  padding: 10px 15px 10px 0px;
}

.checkout {
  background: #eef0ef;
  color: #6d747c;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 5px;
  padding-top: 12px;
  font-size: 14px;
}

.checkout b {
  display: block;
  font-size: 22px;
  line-height: 20px;
}

.checkout button {
  margin: 0;
}

.checkout-action button.movimentation {
  margin-right: 10px;
}
</style>
